/**
 * The page layout contract (client/AGENTS.md "Page layout"; rules.md §3).
 *
 * The shell gives every page the full width of the content column with a 16 px gutter and no
 * cap. A form caps ITSELF with this class so its fields keep a readable line length on a wide
 * monitor; it stays left-aligned (never `mx-auto`). Grids, tables and cards of facts stretch.
 * 896 px is the width the schedule editor already used.
 */
export const FORM_MAX_WIDTH = "max-w-4xl";

/**
 * The app's keyboard focus ring (B-78, round 9): 2 px in the ring colour (the brand amber), the
 * one skypoint-ui's controls draw. A plain link the kit does not style takes it too, so focus
 * looks the same everywhere and shows on the dark top bar and nav.
 */
export const FOCUS_RING =
  "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring";
